import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Menu from "../Menu/Menu";
import "./provedor.css";
import axios from "axios";
import {toast } from 'react-toastify';
import loading_img from "../assets/loading.gif";

import ReactInputMask from 'react-input-mask';

import {
  TextField,
  TextareaAutosize,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Box,
  Paper
} from "@mui/material";

const Dashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


  const [formData, setFormData] = useState({
    nome: "",
    link: "",
    status: "Ativo",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Dados do formulário:", formData);
  };

  const clickCadastrar = async ()=>{
    var idusuario = await localStorage.getItem('@idusuario');
    var token = await localStorage.getItem('@token');

    var nome = document.getElementById('nome').value
    var linktoken = document.getElementById('linktoken').value
    var valor = document.getElementById('valor').value

    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/adicionarProvedor.php',
      headers: {'Content-Type': 'application/json'},
      data: {token: '6d808a40b79c1c6dc0dd1003f58d1c75', token_adm: token,idusuario:idusuario,nome:nome,linktoken:linktoken,valor:valor}
    };

    try {
      setLoading(true)
      var dados = await axios(options);
      setLoading(false)
      var resposta = dados.data;
      console.log(resposta)

      if(resposta.success == false){
        toast.error(resposta.message);
        return false;
      }
      toast.success(resposta.message);

        
    } catch (error) {
      setLoading(false)
         console.log(error)
        toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

    }
  }
  
 

  return (
    <>
      <div style={{ flex: 1 }}>
        <div style={{ flex: 1 }}>
          <Menu />
        </div>
      </div>

      <div className="containerMenu">
      <Paper style={{ padding: "20px", maxWidth: "1000px", margin: "20px auto" }} className="cardView">
      <h2 style={{ textAlign: "center", color: "black",marginBottom:10 }}>Adicionar serviço</h2>

      <Box
      component="form"
      sx={{ maxWidth: 400, margin: "0 auto", display: "flex", flexDirection: "column", gap: 2 }}
      onSubmit={handleSubmit}
    >
      <TextField
        label="Nome"
        name="nome"
        id="nome"
        value={formData.nome}
        onChange={handleChange}
        required
      />
     

      <TextField
          label="ID serviço"
          name="link"
          id="linktoken"
          value={formData.link}
          onChange={handleChange}
          required
        />

      
<ReactInputMask
      mask="R$ 999.999.999,99"
      maskChar=""
      value={formData.valor}
      onChange={(e) => {
        // Remove a máscara e guarda apenas os números
        const rawValue = e.target.value.replace(/[^0-9]/g, '');
        setFormData({ ...formData, valor: rawValue });
      }}
    >
      {(inputProps) => (
        <TextField
          {...inputProps}
          label="Valor"
          name="valor"
          id="valor"
          required
        />
      )}
    </ReactInputMask>
      
      <label style={{fontSize:10}}>*Adicione o id do serviço da seja sem espaços</label>

       
      {loading == false&&(
         <Button type="submit" variant="contained" style={{marginTop:50}} onClick={()=>{clickCadastrar()}}>
         Cadastrar
       </Button>
      )}

      {loading == true&&(
         <Button type="submit" variant="contained" style={{marginTop:50}} >
         <img src={loading_img} alt="" style={{width:25,height:25}} />
       </Button>
      )}
    </Box>
    </Paper>

      </div>
    </>
  );
};

export default Dashboard;
